import { actionTypes } from "./action_types";

import store from "../index";

export const closeModal = () => {
  return store.dispatch({
    type: actionTypes.MAIN_MODAL_CLOSE,
    payload: false,
  });
};

export const openModal = (data) => {
  return store.dispatch({
    type: actionTypes.MAIN_MODAL_OPEN,
    payload: data,
  });
};
